/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import { SEARCH_PATH_NAME } from '../../constants';

const SearchLink = ({ handleRoute, currentSearchTerm }) => (
  <a
    className="search-modal-link"
    onClick={() =>
      handleRoute({
        pathname: `/${SEARCH_PATH_NAME}`,
        query: {
          search_term: currentSearchTerm
        }
      })
    }>
    Show all results for &quot;{currentSearchTerm.toUpperCase()}&quot;
  </a>
);

SearchLink.propTypes = {
  handleRoute: PropTypes.func.isRequired,
  currentSearchTerm: PropTypes.string.isRequired
};

export default SearchLink;
